import { ContactForm } from "@/components/LandingPage/ContactForm";
import { Footer } from "@/components/LandingPage/Footer";
import { GetStarted } from "@/components/LandingPage/GetStarted";
import { TestimonialsSection } from "@/components/LandingPage/TestimonialsSection";
import { Box } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import Head from "next/head";

export default function Page() {
  const t = useTranslations();
  return (
    <>
      <Head>
        <title>{t("contact.title")}</title>
      </Head>
      <Box>
        <ContactForm />
        <TestimonialsSection />
        <GetStarted />
        <Footer />
      </Box>
    </>
  );
}
